export default __webpack_public_path__ + "static/media/not-found.aacab729.png";